/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Video_FailedInputs */



/**
* | output |
* | --- |
* | "Error selecting video file" |
*
* @param {Audio_Description_Export_Select_Video_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_video_failed = /** @type {((inputs?: Audio_Description_Export_Select_Video_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Video_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la sélection du fichier vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Auswählen der Videodatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la selezione del file video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при выборе видеофайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al seleccionar el archivo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择视频文件时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイルの選択中にエラーが発生しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइल चुनने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao selecionar o arquivo de vídeo")
	return /** @type {LocalizedString} */ ("Error selecting video file")
});